export var JumpMode;
(function (JumpMode) {
    JumpMode[JumpMode["similar"] = 0] = "similar";
    JumpMode[JumpMode["latest"] = 1] = "latest";
})(JumpMode || (JumpMode = {}));
//# sourceMappingURL=JumpMode.js.map